import { render, staticRenderFns } from "./OrderActivityComponent.vue?vue&type=template&id=3ab49db4&scoped=true&"
import script from "./OrderActivityComponent.vue?vue&type=script&lang=js&"
export * from "./OrderActivityComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderActivityComponent.vue?vue&type=style&index=0&id=3ab49db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab49db4",
  null
  
)

export default component.exports